import { Outlet, createFileRoute, useNavigate } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';
import { officeOpenTo } from '@regent/shared';
import { Button, EmptyState, Skeleton } from '@/components/ui';
import { Page } from '@/features/shell/page';
import { useMe, useWorkspaceId } from '@/lib/queries';

export const Route = createFileRoute('/w/$workspaceId/office')({ component: OfficeGate });

/** The office is not open yet: platform admins see it, everyone else gets a quiet door. */
function OfficeGate() {
  const me = useMe();
  const ws = useWorkspaceId();
  const navigate = useNavigate();
  if (me === undefined) {
    return (
      <Page title="Office" icon={<Building2 />} scroll={false}>
        <div className="p-6">
          <Skeleton className="h-64 rounded-lg" />
        </div>
      </Page>
    );
  }
  if (!officeOpenTo(me)) {
    return (
      <Page title="Office" icon={<Building2 />}>
        <EmptyState
          icon={<Building2 />}
          title="The office is not open yet"
          description="It is being finished and will open to everyone soon."
          action={<Button onClick={() => void navigate({ to: '/w/$workspaceId/home', params: { workspaceId: ws } })}>Back to home</Button>}
        />
      </Page>
    );
  }
  return <Outlet />;
}
